/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BankIdDetails200,
  GetApiV1BankIdDetails401,
  GetApiV1BankIdDetails404,
  GetApiV1BankIdDetails500,
  GetApiV1BankIdDetailsPathParams,
  GetApiV1BankIdDetailsQueryResponse,
} from "../../types/bankRegistroController/GetApiV1BankIdDetails.ts";
import { bankDetailViewModelSchema } from "../bankDetailViewModelSchema.ts";

export const getApiV1BankIdDetailsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1BankIdDetailsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BankIdDetails200Schema = z.lazy(
  () => bankDetailViewModelSchema,
) as unknown as ToZod<GetApiV1BankIdDetails200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BankIdDetails401Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdDetails401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1BankIdDetails404Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdDetails404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BankIdDetails500Schema =
  z.any() as unknown as ToZod<GetApiV1BankIdDetails500>;

export const getApiV1BankIdDetailsQueryResponseSchema = z.lazy(
  () => getApiV1BankIdDetails200Schema,
) as unknown as ToZod<GetApiV1BankIdDetailsQueryResponse>;
